import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';

import { DowntimeBannerService } from '../services/downtime-banner.service';
import { CaseCreationBlock } from 'src/app/shared/models/downtime-banner.model';

export const DowntimeBannerGuard: CanActivateFn = () => {
  const downtimeBannerService = inject(DowntimeBannerService);
  const router = inject(Router);

  return downtimeBannerService.getDowntimeBanner().pipe(
    map((status) => {
      if (status.active && status.caseCreationBlock === CaseCreationBlock.ALL) {
        return router.parseUrl('/dashboard/open');
      }
      return true;
    })
  );
};
